module.exports = __webpack_public_path__ + "static/media/havilla_partnership_header_image.347b73d0.png";